import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { FullWidthListContainer, IndentContainer } from '@r1-frontend/ui-react/experimental/containers';

import { PassportUpdateButton } from '~/src/features/lk/PassportUpdate/containers/PassportUpdateButton';
import { downNewEnterFlag } from '~/src/features/lk/PassportUpdate/store/actions';
import { TState } from '~/src/store';

/**
 * Информационный попап о необходимости актуализации паспортных данных
 */
export const PassportUpdateInfoPopup = () => {
    const dispatch = useDispatch();
    const { isDataActual, isNewEnter } = useSelector((state: TState) => {
        return ({
            isDataActual: state.passportUpdate.isDataActual,
            isNewEnter: state.passportUpdate.isNewEnter,
        });
    }, shallowEqual);

    const onClose = () => {
        dispatch(downNewEnterFlag());
    };

    return (
        <DefaultPopup
            isOpen={isNewEnter && !isDataActual}
            onClose={onClose}
        >
            <IndentContainer $desktop={[32]} $mobile={[24]}>
                <FullWidthListContainer $direction={'column'} $wrap={'nowrap'} $size={8}>
                    <H3 $withIndent={false}>Обновите свои данные через Госуслуги</H3>
                    <Paragraph4>
                        В&nbsp;соответствии с&nbsp;законом 115-ФЗ мы&nbsp;должны следить, чтобы ваши данные оставались актуальными.
                    </Paragraph4>
                    <ButtonGroup>
                        <PassportUpdateButton size={'medium'}/>
                    </ButtonGroup>
                </FullWidthListContainer>
            </IndentContainer>
        </DefaultPopup>
    );
};
